import ActionTypes from '../constants/ActionTypes';

export default () => next => action => {
  if (action.type === ActionTypes.HARD_REDIRECT_TO) {
    if (typeof window !== 'undefined') {
      window.location.href = action.payload;
    }
  }

  return next(action);
};
